import { MasterDataService } from './../masterdata/masterdata.service';
import { LabEmitterService } from './../common-services/lab-emitter.service';
import { LabMDM } from './../masterdata/models/lab';
import { ResultProcess, StorageType, FileType } from './../masterdata/models/resultProcess';
import { SelectableLab } from './../carrier/selectable-lab';
import { Component, OnInit, Input } from '@angular/core';
import { ErrorHandler } from '../utils/error-handler';
import { MessagesService } from '../messages/messages.service';
import { ResultProcessService } from './mdm-result-service';

@Component({
  selector: 'app-mdm-result-process',
  templateUrl: './mdm-result-process.component.html',
  styleUrls: ['./mdm-result-process.component.css']
})
export class MdmResultProcessComponent implements OnInit {
  @Input() masterLists: ResultProcess[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() checkSelectedLab: SelectableLab;

  isNewMasterList: boolean;
  masterList: ResultProcess;
  displayMasterListDialog: boolean = false;
  selectedLabName: string;
  selectedLab: LabMDM;
  selectedProcess: ResultProcess;
  errorHandler: ErrorHandler = new ErrorHandler;
  selectedMasterList: ResultProcess;
  isName  : string = "name";
  isMergeGroup : string = "mergeGroup";
  isTransferRawData : string = "rawDataRequired";
  isMetaDataFileRequired :string = "metaDataFileRequired";
  isTransferReport : string = "reportRequired";
  isStorageType : string = "storageType";
  isStorageKey : string = "storageKey";
  isStorageDetail : string = "storageDetail";
  isPath : string = "path";
  isSubFolder : string = "subFolder";
  isActive : string = "active";
  isTransferResultFile : string = "resultFileRequired";
  isContainerName : string = "containerName";
  fileOptions : any[] = [];
  storageOptions : any[] = [];
  processList: ResultProcess[] = [];
  selectedLabToBeUsed: SelectableLab;
  isLab: string = "lab";
  labOptions: LabMDM[];
  labOption: LabMDM[] =[];

  constructor(private _messageService: MessagesService, private _labEmitterService: LabEmitterService,
    private processService: ResultProcessService, private _masterDataService: MasterDataService) { }

  ngOnInit() {
    this.getActiveOptionsForDropdowns();
    this._labEmitterService.change.subscribe(lab => {
        this.selectedLabToBeUsed = lab;
    });
    this.selectedLabToBeUsed = JSON.parse(localStorage.getItem('lab'));

    this.storageOptions = [
      { label: "BlobStorage", value: StorageType.BlobStorage }
    ];

    this.fileOptions = [
      { label: "Excel", value: FileType.Excel },
      { label: "csv", value: FileType.csv },
      { label: "HL7", value: FileType.HL7 },
      { label: "resultReport", value: FileType.resultReport }
    ];
  }

  onRowSelect(event) {
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    this.getActiveOptionsForDropdowns();
    this.displayMasterListDialog = true;
  }
  getActiveOptionsForDropdowns() {
    this.labOption = [];
    this._masterDataService.getLabs(true).subscribe(
      results => {
        if (!results) {
          return;
        }   let checkSelectedLabName = this.checkSelectedLab.lab.name;
        this.labOptions = results.data;
        this.labOptions.forEach(lab => {

          if(lab.name == checkSelectedLabName) {
            this.labOption.push(lab);
          }
          if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
            this.selectedLabName = this.masterList.lab.name;
            this.selectedLab = lab;
          }
        })
        this.labOptions = this.labOption;
        if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
          this.selectedLab = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }
    );

  }
  showDialogToAddMasterList() {

    this.isNewMasterList = true;
    this.masterList = new ResultProcess;
    this.masterList.active = true;
    this.masterList.storageType = StorageType.BlobStorage;
    this.selectedProcess = null;
    this.selectedLab = null;
    this.displayMasterListDialog = true;
  }

  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }

  saveMasterList() {
    let masterLists = [...this.masterLists];
    if (this.isNewMasterList) {
      this.saveMasterData(masterLists);
    }
    else {
      this.updateMasterData(masterLists);
    }
  }

  saveMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.processService.addProcess(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists = [...this.masterLists];
        masterLists.push(results.data);
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  updateMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.processService.updateProcess(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  isSaveDisabled() {
    return (this.masterList == undefined || !this.masterList.name || this.masterList.name.trim() === "" || !this.masterList.mergeGroup ||
    this.masterList.mergeGroup.trim() === "" || !this.masterList.storageType || !this.selectedLab
    || !this.masterList.storageKey || this.masterList.storageKey.trim() === ""
    || !this.masterList.storageDetail || this.masterList.storageDetail.trim() === ""
    || !this.masterList.containerName || this.masterList.containerName.trim() === "");
  }
  hashPassword(password: string){
    if(password && password.length > 0) {
    return "*".repeat(password.length)
    }
  }
}

